<header class="header-wrapper">
  <div class="header-leading">
    <button
      class="mobile-menu-button"
      mat-icon-button
      type="button"
      [attr.aria-label]="
        isMobileNavigationOpen ? 'Ocultar navegación' : 'Mostrar navegación'
      "
      [attr.aria-expanded]="isMobileNavigationOpen"
      (click)="toggleMobileNavigation()"
    >
      <mat-icon>{{ isMobileNavigationOpen ? "close" : "menu" }}</mat-icon>
    </button>

    <div class="user-greeting">
      <span
        >Hola, {{ getUserData.name }}!<mat-icon class="wave-icon"
          >waving_hand</mat-icon
        ></span
      >
    </div>
  </div>

  <div class="logo-wrapper">
    <a [routerLink]="[landingUrl]" aria-label="GarageDigital, ir al inicio">
      <img
        src="assets/images/GD_Logotipo_UI.png"
        width="780"
        height="110"
        alt="GarageDigital"
      />
    </a>
  </div>

  <div class="user-actions">
    <gd-notifications-badge></gd-notifications-badge>

    <button
      class="user-button"
      mat-icon-button
      type="button"
      matTooltip="Centro de ayuda"
      aria-label="Centro de ayuda"
      (click)="navigateToHelp()"
    >
      <mat-icon>help_outline</mat-icon>
    </button>

    <button
      class="user-button"
      mat-icon-button
      type="button"
      matTooltip="Menú de usuario"
      aria-label="Menú de usuario"
      [matMenuTriggerFor]="userMenu"
    >
      <mat-icon>account_circle</mat-icon>
    </button>

    <mat-menu #userMenu="matMenu">
      <button gdClarityUnmask mat-menu-item type="button" (click)="navigateToMyAccount()">
        <mat-icon>account_circle</mat-icon>
        <span>Mi cuenta</span>
      </button>
      <button gdClarityUnmask
        *ngIf="canOpenSettings"
        mat-menu-item
        type="button"
        (click)="navigateToSettings()"
      >
        <mat-icon>settings</mat-icon>
        <span>Configuración del taller</span>
      </button>
      <mat-divider></mat-divider>
      <button gdClarityUnmask mat-menu-item type="button" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </mat-menu>
  </div>
</header>
